import { State, VariablesEditorDialogAction, CONFIRMED_SUBMIT_FORM } from '..';
import { tap, ignoreElements } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { EpicDependencies } from '../dependencies.interface';

export const emitStateChangeOnConfirmedSubmit = (
  actions$: Observable<VariablesEditorDialogAction>,
  state$: StateObservable<State>,
  dependencies: EpicDependencies,
): Observable<any> =>
  actions$.pipe(
    ofType(CONFIRMED_SUBMIT_FORM),
    tap(() => dependencies.emitStateChange(state$.value.variableConfiguration)),
    ignoreElements(),
  );
